<template>
  <v-popover
    :boundaries-element="boundariesElement"
    :offset="offset"
    :open="open"
    :placement="placement"
    :popover-class="computedPopoverClasses"
    @update:open="$emit('change', $event)"
  >
    <template slot="popover">
      <div
        class="gl-popover-content"
        :style="{ width: width }"
      >
        <button
          class="gl-popover-content__close"
          type="button"
          @click="close"
        >
          &times;
        </button>

        <div
          v-if="$slots.header"
          class="gl-popover-content__header"
        >
          <slot name="header" />
        </div>

        <div
          v-if="$slots.body"
          class="gl-popover-content__body"
        >
          <slot name="body" />
        </div>

        <div
          v-if="$slots.action"
          class="gl-popover-content__action"
        >
          <slot name="action" />
        </div>
      </div>
    </template>

    <slot />
  </v-popover>
</template>

<script>
export default {
  name: 'GlStatusPopover',
  model: {
    prop: 'open',
    event: 'change',
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: 'auto',
    },
    popoverClass: {
      type: String,
      default: '',
    },
    placement: {
      type: String,
      default: 'top',
    },
    offset: {
      type: [String, Number],
      default: 16,
    },
    boundariesElement: {
      type: String,
      default: 'body',
    },
    zIndex: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    computedPopoverClasses() {
      const classes = ['gl-popover-theme--dark', this.popoverClass]

      if (this.zIndex !== null && this.zIndex !== undefined) {
        classes.push(`gl-popover__z-index-${this.zIndex}`)
      }

      return classes
    },
  },
  methods: {
    close() {
      this.$emit('change', false)
    },
  },
}
</script>

<style>
.gl-popover-theme--dark.tooltip.popover .popover-inner {
  color: var(--Basic-A-900, #fff);
  padding: 0;
  border: none;
  border-radius: 12px;
  background: var(--Basic-900, #091540);
  box-shadow: 0 199px 56px 0 rgba(0, 0, 0, 0),
    0 128px 51px 0 rgba(0, 0, 0, 0.01), 0 72px 43px 0 rgba(0, 0, 0, 0.05),
    0 32px 32px 0 rgba(0, 0, 0, 0.09), 0 8px 18px 0 rgba(0, 0, 0, 0.1);
}
.gl-popover-theme--dark.tooltip.popover .popover-arrow {
  border-color: var(--Basic-900);
}
.gl-popover__z-index-1.tooltip.popover {
  z-index: 1;
}
</style>

<style scoped>
.gl-popover-content {
  position: relative;
  padding: 16px;
}
.gl-popover-content__close {
  position: absolute;
  top: 12px;
  right: 12px;
  background: transparent;
  border: none;
  color: #a0aec0;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  transition: color 0.2s;
}
.gl-popover-content__close:hover {
  color: var(--Basic-A-900, #fff);
}
.gl-popover-content__header {
  margin-bottom: 12px;
  padding-right: 24px;
  color: var(--Basic-A-900, #fff);
  font-size: var(--Size-L, 16px);
  font-style: normal;
  font-weight: 700;
  line-height: var(--Line-Height-XL, 24px);
}
.gl-popover-content__body {
  color: var(--Basic-A-900, #fff);
  font-size: var(--Size-M, 14px);
  font-weight: 600;
  line-height: var(--Line-Height-L, 20px);
  letter-spacing: var(--Letter-Spacing-S, -0.2px);
  margin-bottom: 20px;
}
</style>
